import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const clientAPI = {
  add: async (info) => axios.post(`${baseURL}/clients`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/clients`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/single-client/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/single-client/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/single-client/${idToSearch}`).then((res) => res.data)
};
